import React, { useEffect, useState } from "react";
import { Search, X } from "lucide-react";

export default function SearchFilterBar({
  activeSearch,
  onSearch,
  status,
  setStatus,
  placeholder = "Search by title…",
}) {
  // Local draft state — only commits to `activeSearch` when the user
  // submits (Enter or click). This keeps Firestore reads off the
  // keystroke path.
  const [draft, setDraft] = useState(activeSearch || "");

  useEffect(() => {
    setDraft(activeSearch || "");
  }, [activeSearch]);

  const submit = () => {
    const next = draft.trim();
    if (next === (activeSearch || "")) return;
    onSearch(next);
  };

  const clear = () => {
    setDraft("");
    if (activeSearch) onSearch("");
  };

  const isDirty = draft.trim() !== (activeSearch || "");

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-4">
      <form
        className="relative flex-1 flex items-center gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          submit();
        }}
      >
        <div className="relative flex-1">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder={placeholder}
            className="w-full pl-9 pr-9 py-2 rounded-lg border border-gray-200 bg-white focus:ring-2 focus:ring-leechiuOrange focus:border-transparent outline-none text-sm"
          />
          {draft ? (
            <button
              type="button"
              onClick={clear}
              aria-label="Clear search"
              className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 p-1 rounded"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          ) : null}
        </div>
        <button
          type="submit"
          disabled={!isDirty}
          className="px-4 py-2 rounded-lg bg-leechiuBlue text-white text-sm font-medium hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Search
        </button>
      </form>

      <div className="flex items-center gap-1 bg-white border border-gray-200 rounded-lg p-1 text-sm">
        {[
          { value: "all", label: "All" },
          { value: "published", label: "Published" },
          { value: "draft", label: "Draft" },
        ].map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => setStatus(opt.value)}
            className={`px-3 py-1 rounded-md transition-colors ${
              status === opt.value
                ? "bg-leechiuBlue text-white"
                : "text-gray-600 hover:bg-gray-50"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {activeSearch ? (
        <div className="text-xs text-gray-500">
          Active:{" "}
          <span className="font-medium text-leechiuBlue">"{activeSearch}"</span>
        </div>
      ) : null}
    </div>
  );
}
